import {
  FaTelegramPlane,
  FaTwitter,
  FaDiscord,
  FaGithub,
  FaMediumM,
  FaYoutube,
  FaRedditAlien,
} from "react-icons/fa";
import { TbDiamond, TbWorld } from "react-icons/tb";
import { SOCIALS } from "../../data/site";

const ICONS = {
  telegram: FaTelegramPlane,
  x: FaTwitter,
  discord: FaDiscord,
  github: FaGithub,
  mirror: TbWorld,
  medium: FaMediumM,
  youtube: FaYoutube,
  reddit: FaRedditAlien,
  ton: TbDiamond,
};

export default function Socials({ variant = "grid" }) {
  return (
    <ul className={variant === "row" ? "socials-row" : "home__socials"}>
      {SOCIALS.map((s) => {
        const Icon = ICONS[s.icon] || TbWorld;
        return (
          <li key={s.name}>
            <a
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              className="home__social"
              aria-label={`${s.name} (opens in a new tab)`}
            >
              <Icon aria-hidden="true" />
              <span>{s.name}</span>
            </a>
          </li>
        );
      })}
    </ul>
  );
}
